// extracted by mini-css-extract-plugin
module.exports = {"spinner-container":"_93444fe79c--spinner-container--MePZi"};